module.exports = __webpack_public_path__ + "static/media/pin-form-popup-image.56c6d69e.png";